import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "@mdi/font/css/materialdesignicons.css";
Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: "#730D0B",
        secondary: "#2D3842",
        accent: "#C72A23",
        error: "#B00020",
        success: "#008450",
        warning: "#FFC72E",
        info: "#5576D6",
        background: "#131419",
        failure: "#B81D13",
        standby: "#EFB700",
        running: "#008450",
        maintenance: "#DA530A",
        pmaintenance: "#FBC02D",
        preliability: "#2196F3",
        prepair: "#F57C00"
      },
      light: {
        primary: "#730D0B",
        secondary: "#2D3842",
        accent: "#C72A23",
        error: "#B00020",
        success: "#57AD68",
        warning: "#FFC72E",
        info: "#5576D6",
        background: "#131419",
        failure: "#B81D13",
        standby: "#EFB700",
        running: "#008450",
        maintenance: "#DA530A",
        pmaintenance: "#FBC02D",
        preliability: "#2196F3",
        prepair: "#F57C00"
      }
    },
    light: true
  },
  icons: {
    iconfont: "mdiSvg" // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  }
});

export default vuetify;
